import React, { useState } from 'react';
import ClickAwayListener from 'react-click-away-listener';
import { translate } from '@utils/i18n';
import { Popup } from '@progress/kendo-react-popup';
import { Button } from '@ui';
import { copyProposalPath, editProposalPath, viewAndAcceptProposalsPath } from '@routes';
import SendProposal from '@features/Proposals/SendProposal/SendProposalModalView';
import { namespace } from '../constants';
import './ActionButtonsStyles.scss';
export default function ActionButtons({ proposal }) {
    var _a;
    const [sendProposalModalVisible, setSendProposalModalVisible] = useState(false);
    const anchor = React.useRef(null);
    const [open, setOpen] = React.useState(false);
    const handleClose = () => {
        setOpen(false);
    };
    const handleEdit = () => {
        const w = window.open(editProposalPath({ id: proposal.id }), '_blank', 'noopener');
        if (w) {
            w.opener = null;
        }
    };
    const handlePreview = () => {
        const w = window.open(viewAndAcceptProposalsPath({ token: proposal.emailUrlUuid }), '_blank', 'noopener');
        if (w) {
            w.opener = null;
        }
    };
    const handleSend = () => {
        setSendProposalModalVisible(true);
    };
    const handleDuplicate = () => {
        const w = window.open(copyProposalPath({ id: proposal.id }), '_blank', 'noopener');
        if (w) {
            w.opener = null;
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "action-buttons" },
            React.createElement(Button, { onClick: handleEdit, className: "edit-button" }, translate('actions.edit', { namespace })),
            !proposal.proposalRequest && (React.createElement(React.Fragment, null,
                React.createElement(Button, { variant: "secondary", onClick: handlePreview, className: "preview-button" }, translate('actions.preview', { namespace })),
                React.createElement(Button, { variant: "primary", onClick: handleSend, className: "send-button" }, translate('actions.send', { namespace })),
                React.createElement(Button, { ref: anchor, variant: "secondary", onClick: () => setOpen(!open), className: "more-options-button" },
                    React.createElement("i", { className: "fa-light fa-ellipsis" })),
                React.createElement(Popup, { anchor: anchor.current, show: open, onClose: handleClose },
                    React.createElement(ClickAwayListener, { onClickAway: handleClose },
                        React.createElement("div", { id: "popup_convert", className: "qmb-popup--action-list" },
                            React.createElement("ul", { role: "presentation" },
                                React.createElement("li", { role: "presentation" },
                                    React.createElement("button", { type: "button", onClick: () => {
                                            handleDuplicate();
                                            handleClose();
                                        } },
                                        React.createElement("i", { className: "fa-light fa-copy" }),
                                        translate('actions.duplicate', { namespace })))))))))),
        sendProposalModalVisible && (React.createElement(SendProposal, { proposal: {
                id: proposal.id,
                contactsEmails: (_a = proposal.preparedFor) === null || _a === void 0 ? void 0 : _a.email,
                emailUrlUuid: proposal.emailUrlUuid
            }, onClose: () => setSendProposalModalVisible(false) }))));
}
